import React, { useEffect, useState, useCallback } from 'react'
import { useDispatch } from 'react-redux'
import Modal from 'react-responsive-modal'
import { useFormik } from 'formik'
import * as Yup from 'yup'

import { createDischarge, updateDischarge } from '../../actions/medCenter/discharge'
import { Input } from '../../components/ModalInputs'
import Button from '../../components/Button'
import Confirmation from '../../components/Confirmation/Confirmation'
import styles from './styles.module.css'

const INITIAL_VALUES = {
  iddischarge: null,
  discharge: ''
}

const validationSchema = Yup.object().shape({
  discharge: Yup.string()
    .required('Обязательное поле')
    .max(50, 'Должно быть не более 50 символов')
})

export default function DischargeModal({ open, onClose, data, addMode }) {
  const dispatch = useDispatch()
  const [confirmation, setConfirmation] = useState(false)
  const [isSubmitting, setIsSubmitting] = useState(false)

  const createItem = useCallback(async (values) => {
    setIsSubmitting(true)
    try {
      await dispatch(createDischarge(values))
      onClose()
    } finally {
      setIsSubmitting(false)
    }
  }, [dispatch, onClose])

  const updateItem = useCallback(async (values) => {
    setIsSubmitting(true)
    try {
      await dispatch(updateDischarge(values))
      onClose()
    } finally {
      setIsSubmitting(false)
    }
  }, [dispatch, onClose])

  const {
    values,
    errors,
    touched,
    dirty,
    handleSubmit,
    handleChange,
    handleBlur,
    setValues,
    resetForm
  } = useFormik({
    initialValues: INITIAL_VALUES,
    enableReinitialize: true,
    validationSchema,
    onSubmit: addMode ? createItem : updateItem
  })

  useEffect(() => {
    if (!open) {
      resetForm()
      return
    }
    setValues(addMode ? INITIAL_VALUES : (data || INITIAL_VALUES))
  }, [open, addMode, data, setValues, resetForm])

  const handleCloseModal = useCallback(() => {
    if (dirty) {
      setConfirmation(true)
    } else {
      onClose()
    }
  }, [dirty, onClose])

  const acceptConfirmation = useCallback(() => {
    onClose()
    setConfirmation(false)
  }, [onClose])

  const rejectConfirmation = useCallback(() => {
    setConfirmation(false)
  }, [])

  const getError = useCallback((fieldName) =>
    touched[fieldName] && errors[fieldName],
    [touched, errors]
  )

  return (
    <Modal
      open={open}
      onClose={handleCloseModal}
      classNames={{ modal: styles.modal }}
      closeOnEsc={!dirty}
      closeOnOverlayClick={!dirty}
      showCloseIcon={false}
      animationDuration={200}
      center
    >
      <form onSubmit={handleSubmit} className={styles.modalForm}>
        <div className={styles.modalMain}>
          <h2>{addMode ? 'Добавление освобождения' : 'Редактирование освобождения'}</h2>

          <Input
            name="discharge"
            label="Название"
            value={values.discharge || ''}
            onChange={handleChange}
            onBlur={handleBlur}
            error={getError('discharge')}
            disabled={isSubmitting}
            autoFocus
          />
        </div>

        <div className={styles.modalFooter}>
          <div className={styles.footerInfo} />
          <div className={styles.footerButtons}>
            <Button
              mode="white"
              type="submit"
              loading={isSubmitting}
              disabled={isSubmitting || !dirty}
            >
              Сохранить
            </Button>
            <Button
              mode="white"
              type="button"
              onClick={handleCloseModal}
              disabled={isSubmitting}
            >
              Закрыть
            </Button>
          </div>
        </div>
      </form>

      {confirmation && (
        <Confirmation
          title="Есть несохраненные данные. Уверены что хотите выйти?"
          acceptConfirmation={acceptConfirmation}
          rejectConfirmation={rejectConfirmation}
        />
      )}
    </Modal>
  )
}
